import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_REGISTERED_VOTERS_CONFIG = defineFcm('registered_voters_config')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			optional: true,
			shape: {
				minSignatures: { type: 'number' },
				maxSignatures: { type: 'number' },
				minPercentage: { type: 'number' },
				percentageForPetitions: {
					type: 'array',
					shape: {
						type: 'object',
						shape: {
							petitionId: { type: 'string' },
							percentage: { type: 'number' },
						},
					},
				},
			},
		}),
	)
	.withDefault({
		minSignatures: 100,
		maxSignatures: 1000,
		minPercentage: 0.6,
		percentageForPetitions: [
			{
				petitionId: '123',
				percentage: 0.75,
			},
		],
	})
	.toConfig({
		owner: 'squad-capybara',
		scope: 'signature-service',
		context: 'Controls conditions for displaying registered voters section',
		description:
			'We want to display a voters % if above minimum for petitions with a certain number of signatures. Temporally we will use a fixed percentage for a given set of petitions.',
		template: {
			minSignatures: 100,
			maxSignatures: 1000,
			minPercentage: 0.6,
			percentageForPetitions: [
				{
					petitionId: '123',
					percentage: 0.75,
				},
			],
		},
	});
